import { cn } from "../foundations/cn.js";
import { formatChance } from "./odds.js";
import { RarityIcon } from "./RarityMarker.js";
import { RARITY_FILL, RARITY_LABELS, type RarityTier } from "./rarity.js";

/** How an item's tier shows beside its chance: the tier's dot, or its shape (RarityMarker's). */
export type TierMarker = "dot" | "shape";

export interface OddsTagProps {
  tier: RarityTier;
  /** The chance in percent (0.3 for 0.3%), as published. */
  chance: number;
  /** The tier's name for screen readers; the dot alone carries it visually. */
  tierLabel?: string;
  /** The tier's dot (color alone), or its shape, which reads without color. */
  marker?: TierMarker;
  className?: string;
}

/** One item's published chance, with its tier's dot or shape. The number stays neutral. */
export function OddsTag({ tier, chance, tierLabel, marker = "dot", className }: OddsTagProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-mono text-mono-meta whitespace-nowrap text-text-secondary tabular-nums",
        className,
      )}
    >
      {marker === "shape" ? (
        <RarityIcon tier={tier} size="sm" />
      ) : (
        <span aria-hidden className={cn("size-1.5 shrink-0 rounded-pill", RARITY_FILL[tier])} />
      )}
      <span className="sr-only">{tierLabel ?? RARITY_LABELS[tier]}, </span>
      {formatChance(chance)}
    </span>
  );
}
